/*$(document).ready(() => {
    // Handle a click on the newsletter submit
   /* $("#news-button").click(function () {
        signupToNewsletter($("#news-email").val());
    });*/

/*});*/


$( document ).ready(function() {
    $("#news-button").click(function () {
        signupToNewsletter($("#news-email").val());
    });
});

// Sends a request to the API to sign up to the newsletter
function signupToNewsletter(email)
{
    if (email == "")
    {
        alert("Invalid email");
        return;
    }

    $.ajax({
        url: '/campaign/subscribe',
        type: 'post',
        data: {email: email},
        success: function (response) 
        {
            alert("Thanks for subscribing!")
            window.location.href = '/';
            
        }, 
        error: function (response) 
        {
            console.log(JSON.parse(response.responseText).email[0]);
            alert(JSON.parse(response.responseText).email[0]);
        },
    });
}